<template>
  <div class="service">
    <div v-html="agree"></div>
  </div>
</template>

<script>
export default {
  name: 'contract',
  data () {
    return {
      agree: null
    }
  },
  created () {
    this.getAgree()
  },
  methods: {
    getAgree () {
      this.$http.get('/api/getContract?order_no=' + this.$route.query.order_no).then((res) => {
        this.agree = res.data.data.contract_content
      })
    }
  }
}
</script>

<style scoped lang="less">
.service {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  div {
    margin-top: 10%;
    margin-bottom: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/contract.vue